"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));

var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));

var DeleteIconButton = function DeleteIconButton(_ref) {
  var onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size;
  return react_1.default.createElement(IconButton_1.default, {
    "aria-label": "delete",
    onClick: onClick,
    "data-meta": "delete-button"
  }, react_1.default.createElement(Delete_1.default, {
    fontSize: size
  }));
};

exports.default = DeleteIconButton;